<h2 tabindex="0" [class]="dataHeaderClass()" (click)="toggle()" (keydown.enter)="toggle()" (keydown.space)="toggle()">
	@if (!title) {
		<ng-content select="span" />
	}
	@if (title) {
		<span>{{ title }}</span>
	}
	@if (!locked && open) {
		<i aria-hidden="true" class="fa fa-chevron-up" tabindex="-1"></i>
	}
	@if (!locked && !open) {
		<i aria-hidden="true" class="fa fa-chevron-down" tabindex="-1"></i>
	}
</h2>
<div class="article-content">
	@if (open) {
		<ng-content select="article" />
	}
</div>
